import { render } from "./ProjectInfo.vue?vue&type=template&id=040821f1&ts=true"
import script from "./ProjectInfo.vue?vue&type=script&lang=ts"
export * from "./ProjectInfo.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/matthias/Code/uniki/vergabe/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__